export const phases = {
  "pre-alphabetic": {
    title: "Pre-Alphabetic Phase",
    description: "Your student is in the Pre-Alphabetic Phase. At this stage, they recognize some environmental print and may know some letter names, but they're not yet using letter-sound relationships to read words.",
    recommendations: [
      "🟢 Build phonological awareness with rhyming games and syllable clapping",
      "🟢 Practice letter recognition and letter sounds daily",
      "🟢 Read aloud daily with print referencing (pointing to words as you read)",
      "🟢 Use alphabet books and letter manipulatives"
    ],
    resources: [
      {
        title: "Teaching The 44 Sounds of English",
        description: "Learn how to teach the phonemes of English effectively.",
        link: "https://thriveedservices.com/the-44-phonemes-of-english/"
      },
      {
        title: "Phonological Awareness Activities",
        description: "Strategies and activities for struggling readers.",
        link: "https://thriveedservices.com/phonemic-awareness-strategies-activities-for-struggling-readers/"
      }
    ]
  },
  "partial-alphabetic": {
    title: "Partial Alphabetic Phase",
    description: "Your student is in the Partial Alphabetic Phase. They're beginning to use some letter-sound relationships (typically first and last letters) but aren't yet fully sounding out words.",
    recommendations: [
      "🟢 Use phoneme-grapheme mapping with 3-sound CVC words",
      "🟢 Practice segmenting and blending sounds with Elkonin boxes",
      "🟢 Teach high-frequency words with heart word method",
      "🟢 Daily sound drills with alphabet arcs"
    ],
    resources: [
      {
        title: "CVC Word Building Activities",
        description: "Hands-on activities for building simple words.",
        link: "https://thriveedservices.com/cvc-words/"
      },
      {
        title: "Heart Word Method for Sight Words",
        description: "Learn how to teach sight words effectively.",
        link: "https://thriveedservices.com/heart-words-method-for-teaching-sight-words/"
      }
    ]
  },
  "full-alphabetic": {
    title: "Full Alphabetic Phase",
    description: "Your student is in the Full Alphabetic Phase. They can use letter-sound relationships to decode unfamiliar words and are building their sight word vocabulary.",
    recommendations: [
      "🟢 Practice decoding words with blends and digraphs",
      "🟢 Build fluency with decodable texts at their level",
      "🟢 Use word chains to practice changing one sound at a time",
      "🟢 Introduce simple vowel teams and patterns"
    ],
    resources: [
      {
        title: "Decodable Text Resources",
        description: "Find appropriate texts for building decoding skills.",
        link: "https://thriveedservices.com/where-to-find-decodable-texts/"
      },
      {
        title: "Decoding Strategies",
        description: "Effective techniques for teaching word decoding.",
        link: "https://thriveedservices.com/decoding-strategies/"
      }
    ]
  },
  "consolidated-alphabetic": {
    title: "Consolidated Alphabetic Phase",
    description: "Your student is in the Consolidated Alphabetic Phase. They recognize common spelling patterns and can chunk words into syllables, making their reading more efficient.",
    recommendations: [
      "🟢 Teach advanced vowel patterns and syllable types",
      "🟢 Practice reading multisyllabic words with syllable division",
      "🟢 Build vocabulary through word study and morphology",
      "🟢 Focus on reading fluency and expression"
    ],
    resources: [
      {
        title: "Syllable Division Strategies",
        description: "Learn how to divide words into syllables effectively.",
        link: "https://thriveedservices.com/syllable-division-rules-how-to-divide-words-into-syllables/"
      },
      {
        title: "Morphology Instruction",
        description: "Build vocabulary through meaningful word parts.",
        link: "https://thriveedservices.com/morphology-instruction/"
      }
    ]
  },
  "automatic": {
    title: "Automatic Phase",
    description: "Your student is in the Automatic Phase. They can read most words automatically by sight, allowing them to focus on comprehension rather than decoding.",
    recommendations: [
      "🟢 Focus on comprehension strategies and higher-order thinking",
      "🟢 Build vocabulary through wide reading and word study",
      "🟢 Practice reading with expression and appropriate pacing",
      "🟢 Introduce more complex text structures and genres"
    ],
    resources: [
      {
        title: "Visualization Comprehension Strategy",
        description: "Enhance reading comprehension through visualization.",
        link: "https://thriveedservices.com/reading-comprehension-visualize/"
      },
      {
        title: "11 Fluency Building Activities",
        description: "Activities for reading fluency centers.",
        link: "https://thriveedservices.com/11-activities-for-reading-fluency-centers/"
      }
    ]
  }
};